import BreadCrumb from "Common/BreadCrumb";
import { Container, Card, } from "react-bootstrap";

const BankDetails = () => {
    return (
        <div className="page-content">
            <Container fluid>
                <div className="position-relative mb-3 d-flex justify-content-between align-items-center">
                    <BreadCrumb title='BankDetails' pageTitle="Dashboard" back />
                </div>

                <Card>
                    <Card.Body>
                        <h5>BankDetails</h5>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
};

export default BankDetails;